import { Tool } from '../types';

export const tools: Tool[] = [
  {
    id: "zebracat",
    name: "Zebracat",
    description: "Generate stunning AI art and designs for social media.",
    category: "Design",
    referralLink: "https://zebracat.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/8566480/pexels-photo-8566480.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: true
  },
  {
    id: "rytr",
    name: "Rytr",
    description: "AI writing assistant that helps you create high-quality content in minutes. It's perfect for blogs, emails, and social media posts with its intuitive interface and versatile templates.",
    category: "Writing",
    referralLink: "https://rytr.me/?via=tryai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/267507/pexels-photo-267507.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "fliki",
    name: "Fliki",
    description: "Transform text into professional videos with natural AI voices in minutes. It's revolutionizing content creation for marketers, educators, and social media professionals.",
    category: "Video",
    referralLink: "https://fliki.ai/?via=tryai",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/8566476/pexels-photo-8566476.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "automateed",
    name: "Automateed",
    description: "AI-powered social media automation tool that helps you create, schedule, and manage your content across platforms, saving hours of work each week.",
    category: "Marketing",
    referralLink: "https://automateed.com?ref=by-40196",
    bonusAmount: 35,
    logo: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "dynamiq-ai",
    name: "Dynamiq AI",
    description: "Creates dynamic, personalized content and marketing campaigns with advanced AI technology, helping businesses increase engagement and conversion rates.",
    category: "Marketing",
    referralLink: "https://app.getdynamiq.ai?fpr=benjamin99",
    bonusAmount: 35,
    logo: "https://images.pexels.com/photos/2599244/pexels-photo-2599244.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "chatgpt",
    name: "ChatGPT",
    description: "OpenAI's powerful language model for natural conversations, content creation, and problem-solving.",
    category: "Writing",
    referralLink: "https://chat.openai.com",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/7014932/pexels-photo-7014932.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "bolt-new",
    name: "Bolt.new",
    description: "Create and deploy full-stack web applications instantly with AI assistance.",
    category: "Development",
    referralLink: "https://bolt.new",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/2004161/pexels-photo-2004161.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "grammarly",
    name: "Grammarly",
    description: "AI-powered writing assistant for error-free, clear, and effective communication.",
    category: "Writing",
    referralLink: "https://www.grammarly.com",
    bonusAmount: 20,
    logo: "https://images.pexels.com/photos/8566485/pexels-photo-8566485.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "jasper",
    name: "Jasper AI",
    description: "Create amazing content 10X faster with AI. Perfect for marketing, social media, and blogs.",
    category: "Writing",
    referralLink: "https://www.jasper.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/7014932/pexels-photo-7014932.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "copy-ai",
    name: "Copy.ai",
    description: "Generate high-converting marketing copy in seconds. From emails to social posts.",
    category: "Writing",
    referralLink: "https://www.copy.ai",
    bonusAmount: 20,
    logo: "https://images.pexels.com/photos/8566472/pexels-photo-8566472.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "synthesia",
    name: "Synthesia",
    description: "Create professional AI videos with virtual presenters in minutes.",
    category: "Video",
    referralLink: "https://www.synthesia.io",
    bonusAmount: 35,
    logo: "https://images.pexels.com/photos/8566477/pexels-photo-8566477.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "anyword",
    name: "Anyword",
    description: "AI copywriting platform that generates and optimizes marketing copy.",
    category: "Writing",
    referralLink: "https://anyword.com",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "fireflies",
    name: "Fireflies.ai",
    description: "AI meeting assistant that records, transcribes, and analyzes conversations.",
    category: "Productivity",
    referralLink: "https://fireflies.ai",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/2599244/pexels-photo-2599244.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "notion-ai",
    name: "Notion AI",
    description: "AI-powered writing assistant integrated into Notion for better productivity.",
    category: "Writing",
    referralLink: "https://notion.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/8566484/pexels-photo-8566484.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "writesonic",
    name: "Writesonic",
    description: "Create SEO-optimized content that ranks. Perfect for articles and marketing.",
    category: "Writing",
    referralLink: "https://writesonic.com",
    bonusAmount: 20,
    logo: "https://images.pexels.com/photos/8566473/pexels-photo-8566473.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "claude",
    name: "Claude AI",
    description: "Advanced AI assistant for writing, analysis, and coding by Anthropic.",
    category: "Writing",
    referralLink: "https://claude.ai",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/2599244/pexels-photo-2599244.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "frase",
    name: "Frase",
    description: "AI-powered SEO content optimization and research platform.",
    category: "Writing",
    referralLink: "https://frase.io",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/8566474/pexels-photo-8566474.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "invideo",
    name: "InVideo",
    description: "Create professional videos online with AI-powered templates.",
    category: "Video",
    referralLink: "https://invideo.io",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/2544554/pexels-photo-2544554.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "cutout-pro",
    name: "Cutout.Pro",
    description: "AI-powered image and video editing platform for professionals.",
    category: "Design",
    referralLink: "https://www.cutout.pro",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/1762851/pexels-photo-1762851.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "leonardo-ai",
    name: "Leonardo.Ai",
    description: "Create stunning AI-generated artwork and illustrations.",
    category: "Design",
    referralLink: "https://leonardo.ai",
    bonusAmount: 35,
    logo: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "polybuzz",
    name: "PolyBuzz",
    description: "AI-powered content creation and optimization platform.",
    category: "Writing",
    referralLink: "https://polybuzz.ai",
    bonusAmount: 20,
    logo: "https://images.pexels.com/photos/3756766/pexels-photo-3756766.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "prowritingaid",
    name: "ProWritingAid",
    description: "Advanced grammar checker and writing mentor powered by AI.",
    category: "Writing",
    referralLink: "https://prowritingaid.com",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/267507/pexels-photo-267507.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "kimiyi",
    name: "Kimiyi AI",
    description: "AI-powered content creation and optimization tool.",
    category: "Writing",
    referralLink: "https://kimiyi.ai",
    bonusAmount: 20,
    logo: "https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "textcortex",
    name: "TextCortex",
    description: "AI writing assistant for creating engaging content quickly.",
    category: "Writing",
    referralLink: "https://textcortex.com",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "scalenut",
    name: "Scalenut",
    description: "AI-powered SEO content optimization platform.",
    category: "Writing",
    referralLink: "https://www.scalenut.com",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/8566475/pexels-photo-8566475.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "murf",
    name: "Murf AI",
    description: "Create natural-sounding voiceovers with AI technology.",
    category: "Audio",
    referralLink: "https://murf.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/8566479/pexels-photo-8566479.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "descript",
    name: "Descript",
    description: "All-in-one audio and video editing platform powered by AI.",
    category: "Video",
    referralLink: "https://www.descript.com",
    bonusAmount: 35,
    logo: "https://images.pexels.com/photos/8566478/pexels-photo-8566478.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "hypotenuse",
    name: "Hypotenuse",
    description: "AI content generation platform for marketing and e-commerce.",
    category: "Writing",
    referralLink: "https://hypotenuse.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "lex",
    name: "Lex",
    description: "AI writing assistant for better, faster content creation.",
    category: "Writing",
    referralLink: "https://lex.page",
    bonusAmount: 20,
    logo: "https://images.pexels.com/photos/3756766/pexels-photo-3756766.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "neuroflash",
    name: "Neuroflash",
    description: "AI-powered content creation and optimization platform.",
    category: "Writing",
    referralLink: "https://neuroflash.com",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/267507/pexels-photo-267507.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "magai",
    name: "Magai",
    description: "AI content generation and optimization tool.",
    category: "Writing",
    referralLink: "https://magai.ai",
    bonusAmount: 20,
    logo: "https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "durable",
    name: "Durable AI",
    description: "AI-powered website builder and business tools.",
    category: "Development",
    referralLink: "https://durable.ai",
    bonusAmount: 35,
    logo: "https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "krisp",
    name: "Krisp.ai",
    description: "AI-powered noise cancellation for clear audio calls.",
    category: "Audio",
    referralLink: "https://krisp.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/3756766/pexels-photo-3756766.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "heygen",
    name: "HeyGen",
    description: "Create AI-powered video content with virtual presenters.",
    category: "Video",
    referralLink: "https://www.heygen.com",
    bonusAmount: 35,
    logo: "https://images.pexels.com/photos/2544554/pexels-photo-2544554.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "perplexity",
    name: "Perplexity AI",
    description: "AI-powered search engine for instant, accurate answers.",
    category: "Research",
    referralLink: "https://www.perplexity.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/267507/pexels-photo-267507.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "lumen5",
    name: "Lumen5",
    description: "Transform text content into engaging videos with AI.",
    category: "Video",
    referralLink: "https://lumen5.com",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/2544554/pexels-photo-2544554.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "pictory",
    name: "Pictory",
    description: "Automatically create videos from long-form content.",
    category: "Video",
    referralLink: "https://pictory.ai",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/8566476/pexels-photo-8566476.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "taplio",
    name: "Taplio",
    description: "AI-powered LinkedIn automation and content creation.",
    category: "Marketing",
    referralLink: "https://taplio.com",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "kaiber",
    name: "Kaiber AI",
    description: "Create stunning AI-generated videos and animations.",
    category: "Video",
    referralLink: "https://kaiber.ai",
    bonusAmount: 35,
    logo: "https://images.pexels.com/photos/2544554/pexels-photo-2544554.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "creaitor",
    name: "Creaitor AI",
    description: "AI-powered content creation platform for marketers.",
    category: "Writing",
    referralLink: "https://creaitor.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "tome",
    name: "Tome",
    description: "AI-powered storytelling and presentation platform.",
    category: "Productivity",
    referralLink: "https://tome.app",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/7376/startup-photos.jpg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "cleanup-pictures",
    name: "Cleanup.pictures",
    description: "Remove unwanted objects from images using AI.",
    category: "Design",
    referralLink: "https://cleanup.pictures",
    bonusAmount: 20,
    logo: "https://images.pexels.com/photos/1762851/pexels-photo-1762851.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "monica",
    name: "Monica AI",
    description: "AI-powered personal assistant for productivity.",
    category: "Productivity",
    referralLink: "https://monica.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/2599244/pexels-photo-2599244.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "studyx",
    name: "StudyX",
    description: "AI-powered learning and study assistance platform.",
    category: "Education",
    referralLink: "https://studyx.ai",
    bonusAmount: 20,
    logo: "https://images.pexels.com/photos/267507/pexels-photo-267507.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "zeemo",
    name: "Zeemo",
    description: "AI-powered video creation and editing platform.",
    category: "Video",
    referralLink: "https://zeemo.ai",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/2544554/pexels-photo-2544554.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "peppertype",
    name: "Peppertype.ai",
    description: "AI content writer for marketing and social media.",
    category: "Writing",
    referralLink: "https://peppertype.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "crushon",
    name: "CrushOn.AI",
    description: "AI-powered social media content creation platform.",
    category: "Marketing",
    referralLink: "https://crushon.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/2599244/pexels-photo-2599244.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "elevenlabs",
    name: "ElevenLabs",
    description: "Create ultra-realistic AI voices for any content.",
    category: "Audio",
    referralLink: "https://elevenlabs.io",
    bonusAmount: 35,
    logo: "https://images.pexels.com/photos/3756766/pexels-photo-3756766.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "aiseo",
    name: "AISEO",
    description: "AI-powered content writing and SEO optimization tool.",
    category: "Writing",
    referralLink: "https://aiseo.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/267507/pexels-photo-267507.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "suno",
    name: "Suno",
    description: "Create original music and songs with AI.",
    category: "Audio",
    referralLink: "https://suno.ai",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/3756766/pexels-photo-3756766.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "quillbot",
    name: "QuillBot",
    description: "AI-powered writing and paraphrasing tool.",
    category: "Writing",
    referralLink: "https://quillbot.com",
    bonusAmount: 20,
    logo: "https://images.pexels.com/photos/267507/pexels-photo-267507.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "getgenie",
    name: "GetGenie",
    description: "AI content writer for WordPress and marketing.",
    category: "Writing",
    referralLink: "https://getgenie.ai",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "longshot",
    name: "LongShot AI",
    description: "AI-powered long-form content creation platform.",
    category: "Writing",
    referralLink: "https://longshot.ai",
    bonusAmount: 30,
    logo: "https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  },
  {
    id: "chatpdf",
    name: "ChatPDF",
    description: "Chat with any PDF document using AI technology.",
    category: "Productivity",
    referralLink: "https://chatpdf.com",
    bonusAmount: 25,
    logo: "https://images.pexels.com/photos/2599244/pexels-photo-2599244.jpeg",
    clicks: 0,
    signups: 0,
    isFeatured: false
  }
];

export const getFeaturedTool = (): Tool => {
  return tools.find(tool => tool.isFeatured) || tools[0];
};

export const getToolsByCategory = (category: string): Tool[] => {
  if (category === 'All') {
    return tools;
  }
  return tools.filter(tool => tool.category === category);
};

export const getToolById = (id: string): Tool | undefined => {
  return tools.find(tool => tool.id === id);
};